import React from 'react';
import { FaGlobeAmericas, FaCheckCircle, FaClock } from 'react-icons/fa';
import StatsCard from './StatsCard';

const LandingPageAnalytics = ({ total, published, drafts, userLimits }) => {
  console.log('LandingPageAnalytics props:', { total, published, drafts, userLimits });
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
      <StatsCard
        title="Total Pages"
        value={total}
        icon={FaGlobeAmericas}
        showLimit={true}
        current={total}
        limit={userLimits.maxLandingPages === -1 ? -1 : userLimits.maxLandingPages}
      />
      
      <StatsCard
        title="Published"
        value={published}
        icon={FaCheckCircle}
      />
      
      <StatsCard
        title="Drafts"
        value={drafts}
        icon={FaClock}
      />
    </div>
  );
};

export default LandingPageAnalytics;
